import { AxiosRequestHeaders } from 'axios';
import axiosObject from './config';

// exporting globally.
export { axiosObject } from './config';

export enum HttpMethods {
    POST = "post",
    GET = "get",
    PUT = "put",
    PATCH = "patch",
    DELETE = "delete",
}

export const baseURL = import.meta.env.VITE_API_URL;
console.log("baseURL : ", baseURL )
export type MakeRequest = {
    url: string;
    method: HttpMethods;
    data?: unknown;
    params?: unknown;
    headers?: AxiosRequestHeaders;
    signal?: AbortSignal;
    onUploadProgress?: any;
};

export const makeRequest = async (req: MakeRequest) => {
    const { url, method, data, params, headers, signal, onUploadProgress } = req;

    return axiosObject({
        url: baseURL + url,
        method,
        data,
        params,
        headers,
        signal,
        onUploadProgress,
    }).then((res) => {
        return res.data;
    });
};

